export default __webpack_public_path__ + "static/media/trav_logo.e2adba62.png";